/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jshint freeze: false */
"use strict";

//-------------------------------------------
function pad2(n) {
    /// <summary>Ensure integers are 2 digits</summary>
    return n < 10 ? "0".concat(n) : n;
}


//-------------------------------------------
function pad3(n) {
    /// <summary>Ensure integers are 3 digits</summary>
    return n < 100
        ? (n < 10 ? "00".concat(n) : "0".concat(n))
        : n;
}

//-------------------------------------------
function formatOffset(offset) {
    var hours, minutes, formatted = null;
    if (typeof offset === "number" && !isNaN(offset)) {
        if (offset === 0) {
            formatted = "Z";
        } else {
            formatted = offset < 0 ? "+" : "-";
            offset = Math.abs(offset);
            hours = Math.floor(offset / 60);
            minutes = offset - (hours * 60);
            formatted = formatted.concat(pad2(hours)).concat(":").concat(pad2(minutes));
        }
    }
    return formatted;
}


//-------------------------------------------
Date.prototype.toJSON = function dateToJSON() {
    /// <summary>
    /// Convert the date to UTC and serialize to the string representation
    /// of a datetime. Format: (yyyy-MM-ddTHH:mm:ss.fffK)
    /// </summary>
    /// <example>1999-12-31T18:01:01.001+01:00</example>
    return ""
        .concat(this.getFullYear()).concat("-")
        .concat(pad2(this.getMonth() + 1)).concat("-")
        .concat(pad2(this.getDate())).concat("T")
        .concat(pad2(this.getHours())).concat(":")
        .concat(pad2(this.getMinutes())).concat(":")
        .concat(pad2(this.getSeconds())).concat(".")
        .concat(pad3(this.getMilliseconds()))
        .concat(formatOffset(this.getTimezoneOffset()));
};


//-------------------------------------------
Date.prototype.toJSONDate = function dateToJSONDate() {
    /// <summary>
    /// Serialize a javascript date to the string representation
    /// of a date. Format: (yyyy-MM-dd)
    /// </summary>
    /// <example>1999-12-31</example>
    return ""
        .concat(this.getFullYear()).concat("-")
        .concat(pad2(this.getMonth() + 1)).concat("-")
        .concat(pad2(this.getDate()));
};


//-------------------------------------------
Date.fromJSON = function dateFromJSON(value) {
    /// <summary>
    /// De-serialize a ISO 8601 string representation of a UTC datetime to
    /// the javascript date object in local timezone.
    /// Expected Format: (yyyy-MM-ddTHH:mm:ss.fffK)
    /// </summary>
    if (typeof value !== "string" || value.length < 24) { return null; }

    var hours = 0, minutes = 0, multiplier = 0;

    // Calculate offset (hours and minutes)
    if (value.length >= 29) {
        multiplier = value.substr(23, 1) === "-" ? 60000 : -60000;
        hours = parseInt(value.substr(24, 2), 10);
        minutes = parseInt(value.substr(27, 2), 10);
    }

    return new Date(Date.UTC(
        parseInt(value.substr(0, 4), 10),
        parseInt(value.substr(5, 2), 10) - 1,
        parseInt(value.substr(8, 2), 10),
        parseInt(value.substr(11, 2), 10),
        parseInt(value.substr(14, 2), 10),
        parseInt(value.substr(17, 2), 10),
        parseInt(value.substr(20, 3), 10)
    ) + multiplier * (60 * hours + minutes));
};


//-------------------------------------------
Date.fromJSONDate = function dateFromJSONDate(value) {
    /// <summary>
    /// De-serialize a ISO 8601 string representation of a date to
    /// the javascript date object.
    /// Expected Format: (yyyy-MM-dd)
    /// </summary>
    if (typeof value !== "string" || value.length < 10) { return null; }
    return new Date(
        parseInt(value.substr(0, 4), 10),
        parseInt(value.substr(5, 2), 10) - 1,
        parseInt(value.substr(8, 2), 10)
    );
};


//-------------------------------------------
Date.min = Date.min || new Date(-8640000000000000);
    /// <summary>
    /// Represents the smallest possible javascript Date.
    /// More info: http://stackoverflow.com/questions/11526504/minimum-and-maximum-date
    /// </summary>

module.exports = Date;




//////////////////
// WEBPACK FOOTER
// ./~/pli/date/DateExtensions.js
// module id = 437
// module chunks = 49